import { render, staticRenderFns } from "./ParadigmLogo.vue?vue&type=template&id=6f56b543&scoped=true&"
import script from "./ParadigmLogo.vue?vue&type=script&lang=js&"
export * from "./ParadigmLogo.vue?vue&type=script&lang=js&"
import style0 from "./ParadigmLogo.vue?vue&type=style&index=0&id=6f56b543&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f56b543",
  null
  
)

export default component.exports